import { AuthService } from './authService';
import { ReleaseNoteVersion, DeployedVersion } from '../types/releaseNote';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

/**
 * Read-only tilgang til release notes / deployert-versjon fra master (via tenant-API-et).
 * Data er delt paa tvers av tenants (gjelder produktet).
 */
class ReleaseNotesService {
  private baseUrl = `${API_BASE_URL}/release-notes`;

  /** Alle release notes gruppert paa versjon (nyeste foerst). */
  async getGrouped(): Promise<ReleaseNoteVersion[]> {
    const response = await AuthService.authenticatedGet(this.baseUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  }

  /** Naavaerende versjon per miljoe. */
  async getDeployedVersions(): Promise<DeployedVersion[]> {
    const response = await AuthService.authenticatedGet(`${this.baseUrl}/deployed-version`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  }

  /** Full deploy-historikk (alle rader), nyeste foerst. */
  async getDeployedVersionHistory(): Promise<DeployedVersion[]> {
    const response = await AuthService.authenticatedGet(`${this.baseUrl}/deployed-version/history`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  }
}

export const releaseNotesService = new ReleaseNotesService();
export default releaseNotesService;
